import React from 'react'
import MyButton from '../../../../UI/form/MyButton'
import { useState } from 'react'
import { useEffect } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import FactorySelectMain from '../../../../form/fields/FactorySelectMain'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import FactoryLineSelectMain from '../../../../form/fields/FactoryLineSelectMain'
import GoodSelectSeriesInPack from './fields/GoodSelectSeriesInPack'
import MyCheckBox from '../../../../UI/form/MyCheckBox'
import SeriesInPackNumberFrom from './fields/SeriesInPackNumberFrom'
import SeriesInPackNumberTo from './fields/SeriesInPackNumberTo'
import { transferSeriesInFactoryLineAPI } from '../../../../../api/series/seriesAPI'

const AddSeriesInFactoryLineForm = ({ packId, setOpen }) => {

    const [data, setData] = useState({}) // Дані з форми

	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [loading, setLoading] = useState(false)
	const [success, setSuccess] = useState('')
	const [error, setError] = useState('')

	useEffect(() => {
		checkValid(valid, setIsValidForm)
	}, [valid])

    useEffect(() => {
        setValidNumbers()
    }, [data.isAllGoods])

	const add = () => {
		setLoading(true)
		setError('')
        setSuccess('')
        const data = getDataFoBd()
		transferSeriesInFactoryLineAPI(data).then(data => {
            setSuccess('Товари успішно передані у виробництво')
            setTimeout(() => {
                setLoading(false)
                setOpen(false)
            }, 3000)
		}).catch(e => {
			setError(responseError(e))
			setLoading(false)
		})
	}

    const setValidNumbers = () => {
        if (data.isAllGoods) { // Якщо всі товари, то номер ставимо валідним. Інакше йде перевірка за самим полем
            updateValidate(setValid, 'numberFrom', true)
            updateValidate(setValid, 'numberTo', true)
        }
    }

    const getDataFoBd = () => {
        let dataForBd = {
            packId: packId,
            factoryId: data.factoryId,
            factoryLineId: data.factoryLineId,
            goodId: data.goodId,
            isAllGoods: data.isAllGoods && data.isAllGoods === true ? true : false,
        }

        if (!data.isAllGoods) { // Якщо не всі товари
            dataForBd['numberFrom'] = data.numberFrom
            dataForBd['numberTo'] = data.numberTo
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
		<div>
			<p>Товар з кінцевою серією буде переданий на виробництво у певний цех та певну лінію</p>
			<p>Можна передати як всю партію, так і конкретні серії товарів</p>
		</div>

        {
			formDataProductIsField('factoryId', 'transferGoodsInFactoryLine') ?
				<FactorySelectMain
					required={formDataProductRequiredField('factoryId', 'transferGoodsInFactoryLine')}
					setValidate={e => updateValidate(setValid, 'factoryId', e)}
					setValueForm={e => setValueForm(setData, 'factoryId', e)}
					forciblyValue={data && data.factoryId ? data.factoryId : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('factoryLineId', 'transferGoodsInFactoryLine') ?
				<FactoryLineSelectMain
                    factoryId={data && data.factoryId ? data.factoryId : null}
					required={formDataProductRequiredField('factoryLineId', 'transferGoodsInFactoryLine')}
					setValidate={e => updateValidate(setValid, 'factoryLineId', e)}
					setValueForm={e => setValueForm(setData, 'factoryLineId', e)}
					forciblyValue={data && data.factoryLineId ? data.factoryLineId : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('goodId', 'transferGoodsInFactoryLine') ?
				<GoodSelectSeriesInPack
                    packId={packId}
                    factoryLineId={data && data.factoryLineId ? data.factoryLineId : null}
					required={formDataProductRequiredField('goodId', 'transferGoodsInFactoryLine')}
					setValidate={e => updateValidate(setValid, 'goodId', e)}
					setValueForm={e => setValueForm(setData, 'goodId', e)}
					forciblyValue={data && data.goodId ? data.goodId : ''}
				/>
			: ''
        }
        <div>
            <MyCheckBox 
                value={data.isAllGoods === true ? data.isAllGoods : false}
                setValue={e => setValueForm(setData, 'isAllGoods', e)}
                label={'Передати всю партію у виробництво'}
            />
        </div>
        {
            !data.isAllGoods ?
                <div className='myFormSimple__divWrap'>
                    <p>Вкажіть початковий та кінцевий номер товару в партії для передачі</p>
                    <div>
                        {
                            formDataProductIsField('numberFrom', 'transferGoodsInFactoryLine') ?
                                <SeriesInPackNumberFrom
                                    required={formDataProductRequiredField('numberFrom', 'transferGoodsInFactoryLine')}
                                    setValidate={e => updateValidate(setValid, 'numberFrom', e)}
                                    setValueForm={e => setValueForm(setData, 'numberFrom', e)}
                                    forciblyValue={data && data.numberFrom ? data.numberFrom : ''}
                                />
                            : ''
                        }
                        {
                            formDataProductIsField('numberTo', 'transferGoodsInFactoryLine') ?
                                <SeriesInPackNumberTo
                                    required={formDataProductRequiredField('numberTo', 'transferGoodsInFactoryLine')}
                                    setValidate={e => updateValidate(setValid, 'numberTo', e)}
                                    setValueForm={e => setValueForm(setData, 'numberTo', e)}
                                    forciblyValue={data && data.numberTo ? data.numberTo : ''}
                                />
                            : ''
                        }
                    </div>
                </div>
            : ''
        }

        {
			success ?
				<div className='success'>
					{ success }
				</div>
			: ''
		}
        {
			error ?
				<div className='error'>
					{ error }
				</div>
			: ''
		}

        <MyButton
            size='md'
            onClick={add}
            disabled={!isValidForm || loading ? true : false}
        >
            Додати товари у виробництво
        </MyButton>
    </div>
  )
}

export default AddSeriesInFactoryLineForm